import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { OperationDirectionEntity } from 'src/entities/OperationDirection.entity';
import arrayUtil from 'src/utils/array.util';

const getOperations = (ids: number[], variant: 'v2' | 'v3') => async () => {
  const basePath = variant === 'v3' ? '/api/v3/operation_directions' : '/api/v4/operation_directions';
  const params = arrayUtil.convertToParams('ids', ids);
  const url = [
    basePath,
    params,
  ].join('?');

  const response = await axios.get<OperationDirectionEntity>(url);

  return response.data;
};

export const useOperationDirectionsRequestQuery = (ids: number[], variant: 'v2' | 'v3') => useQuery({
  queryKey: ['useOperationDirectionsRequestQuery', [ids], variant],
  queryFn: getOperations(ids, variant),
  enabled: Boolean(ids.length),
  refetchOnWindowFocus: false,
  staleTime: Infinity,
});
